<template>
  <div data-component-group="filter-forms" data-component="events-promotions">
    <FiltersForm
      v-model="countries"
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="dates"
        placeholder="Dates"
        :config="dateConfig"
        :on-change="onChangeDate"
      />

      <v-autocomplete
        clearable
        v-model="status"
        :items="promotionsStatuses"
        prepend-inner-icon="download_done"
        return-object
        item-title="name"
        label="Status"
      />
    </FiltersForm>
  </div>
</template>

<script>
import FiltersForm from '../FiltersBase';
import { debounce } from '@/utils';
import { v1 as uuidv1 } from 'uuid';
import { mapGetters } from 'vuex';

const debouncer = debounce({
  id: uuidv1(),
  timeout: 500
});

export default {
  components: {
    FiltersForm,
  },
  data() {
    return {
      search: null,
      dates: '',
      countries: [],
      dateConfig: {
        mode: 'range',
      },
      status: null,
    };
  },
  computed: {
    ...mapGetters('events', ['promotionsStatuses']),
    hasFilters() {
      const { search, countries, dates, status } = this;
      return search !== null || countries.length > 0 || dates !== '' || status !== null;
    },
  },
  emits: ['filter', 'clearFilters'],
  methods: {
    onFilter() {
      const { search, countries, dates, status } = this;
      this.$emit('filter', {
        search,
        countries,
        dates: dates !== '' ? dates : null,
        status: status ? status.id : null,
      });
    },
    onClearFilters() {
      this.search = null;
      this.countries = [];
      this.dates = '';
      this.status = null;
      this.$emit('clearFilters');
    },
    onChangeDate(dates) {
      this.dates = dates;
    },
  },
};
</script>